import { FunctionComponent } from 'react'
import { toCurrency } from 'utilities/number.util'

// Formatted currency value
const CurrencyLabel: FunctionComponent<{ children: number }> = ({
  children,
}) => <>{toCurrency(children)}</>

export default CurrencyLabel
